
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { AppLoader } from '@/lib/router/components';

interface PageProps {
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
  noPadding?: boolean;
  fullHeight?: boolean;
  /** When true, removes bottom padding for canvas-style layouts */
  noBottomPadding?: boolean;
}

export function Page({ children, className, isLoading, noPadding, fullHeight, noBottomPadding }: PageProps) {
  const containerClassName = cn(
    !noPadding && "px-3 sm:px-4 md:px-6 lg:px-8",
    noPadding && "p-0",
    fullHeight && "h-full flex flex-col",
    fullHeight && !noBottomPadding && "pb-16",
    className
  );

  return (
    <div className={containerClassName}>
      {isLoading ? <AppLoader inline size="sm" /> : children}
    </div>
  );
} 
